<template>
    <div id="directives" :class="['flex-center m-no-margin-l m-row span', Classes().directives]">
        <Directive
            v-for="(directive, d) in directives"
            :key="d"
            :id="ID(d)"
            :directive="directive"
            :totalDirectives="directives.length"
            :index="d"
            :contentInitiated="contentInitiated"
            :mobile="mobile"
            @content-initiated="$emit('content-initiated', $event)"
        />
    </div>
</template>

<script>
import Directive from "@/components/Projects/Project/Detail/Directives/Directive.vue";
import { projectModel } from "@/models";

export default {
    name: "ProjectDetailDirectives",
    props: {
        directives: Array,
        contentInitiated: Boolean,
        mobile: Boolean
    },
    components: { Directive },
    methods: {
        ID: function(index) {
            const id = `directive-${index + 1}`;
            return !this.mobile ? id : `m-${id}`;
        },
        Classes: function() {
            return {
                directives: !this.mobile ? "" : "m-directives"
            }
        }
    },
    emits: [ ...projectModel.emits ]
};
</script>